import { render, staticRenderFns } from "./ossConfigForm.vue?vue&type=template&id=5edd1966&scoped=true"
import script from "./ossConfigForm.vue?vue&type=script&lang=js"
export * from "./ossConfigForm.vue?vue&type=script&lang=js"
import style0 from "./ossConfigForm.vue?vue&type=style&index=0&id=5edd1966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edd1966",
  null
  
)

export default component.exports